module.exports = __webpack_public_path__ + "img/papper.848018c8.svg";